/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	GetUserAccessQuery$data as GetUserAccessQuery,
	GetUserAccessQuery$variables as GetUserAccessQueryVariables,
} from '../__generated__/GetUserAccessQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { GetUserAccessQuery$data } from '../__generated__/GetUserAccessQuery.graphql.ts';
export type GetUserAccessQuery_confluence_tenantContext_ConfluenceTenantContext_licensedProducts_LicensedProduct = NonNullable<GetUserAccessQuery$data['confluence_tenantContext']>['licensedProducts'][number];
export type GetUserAccessQuery_confluence_tenantContext_ConfluenceTenantContext = NonNullable<GetUserAccessQuery$data['confluence_tenantContext']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum LicenseStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  UNLICENSED = "UNLICENSED",
}

